import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useVideosActions } from 'src/store/videos/actions';
import { saveAs } from 'file-saver';
import { useDispatch, useSelector } from 'react-redux';
import { uploadPartUrl } from 'src/components/utilities/utils';
import { RootState } from 'src/store/reducers/state';
import { useForm } from 'react-hook-form';
import { uploadImageToS3 } from 'src/components/utilities/utils';
import { toast } from 'react-toastify';
import { UpdateResourceUploadModel } from 'src/models/videosModel';
import axios from 'axios';
import JSZip from 'jszip';
interface IProps {
  videoId: string;
}

const MediaInfo: React.FC<IProps> = ({ videoId }) => {
  const dispatch = useDispatch();
  const videoActions = useVideosActions(dispatch);
  const { id } = useParams<string>();
  const [source, SetSource] = useState(2);
  const [uploadPercentage, setUploadPercentage] = useState<number>(0);
  const rootUrl = process.env.REACT_APP_BASE_API_URL;
  const [selectedFile, setSelectedFile] = useState<any>('');
  const [videoName, setVideoName] = useState<string>('');
  const [showWarning, setShowWarning] = useState<boolean>(false);
  const secondaryUploadMediaBtn = useRef<HTMLInputElement>(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [resourceName, setResourceName] = useState<string>('');
  const [resourceType, setResourceType] = useState<string>('');
  const [uploadedFile, setUploadedFile] = useState<File>();
  const [uploadedFileUrl, setUploadedFileUrl] = useState<File>();
  const [isEditingUrl, setIsEditingUrl] = useState(false);
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const [downloadingKey, setDownloadingKey] = useState<string | null>(null);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [slideCount, setSlideCount] = useState(0);
  const [isZippingSlides, setIsZippingSlides] = useState(false);
  const [slidesZipProgress, setSlidesZipProgress] = useState(0);
  const { videoMedia, singleVideo, productAccess, liveMedia, isCancelUpload, resourceId } =
    useSelector((state: RootState) => {
      return {
        videoMedia: state.videos.videoMedia,
        singleVideo: state.videos.singleVideo,
        productAccess: state.videos.isProductAccess,
        liveMedia: state.videos.liveMedia,
        isCancelUpload: state.videos.isCancelUpload,
        resourceId: state.videos.resourceId
      };
    });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    control,
    setValue
  } = useForm();
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    setValue: setValue1,
    watch: watch1
  } = useForm();

  const onSubmit = (data: any) => {
    videoActions.saveVideoMediaRequest({ ...data, videoId });
  };
  const handleResourceUpload = async (files: any) => {
    setUploadedFile(files && files[0]);
    setResourceName(files[0].name);
    setResourceType(files[0].type);
    setSelectedFile(files[0].name);
  };
  const handleCopyLiveStudioUrl = () => {
    const liveStudioUrl = `${window.location.origin}/videos/live-event/${videoId}`;
    navigator.clipboard.writeText(liveStudioUrl).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    });
  };
  useEffect(() => {
    if (uploadedFile) {
      fetchSignedURL();
    }
  }, [uploadedFile]);

  useEffect(() => {
    if (videoMedia && videoMedia.isSecondary) {
      setValue('secondaryLiveSlidesType', videoMedia.secondaryLiveSlidesType);
      setValue('secondaryLiveMedia', videoMedia.secondaryLiveMedia);
      setValue('isSecondary', videoMedia.isSecondary);
    }
  }, [videoMedia]);
  useEffect(() => {
    if (singleVideo && singleVideo.externalContentUrl) {
      setValue1('externalContentUrl', singleVideo.externalContentUrl);
    }
  }, [singleVideo]);

  useEffect(() => {
    if (singleVideo.videoContentType == 1) {
      videoActions.getResourceDetailRequest(videoId);
    }
  }, [singleVideo]);

  const handleChangeVideoSource = (sourceOption: any) => {
    videoActions.updateLiveStreamSourceRequest({ videoId, option: sourceOption });
    if (videoId) {
      videoActions.getVideoMediaRequest(videoId);
    }
  };
  const isSecondary = watch('isSecondary');
  const secondaryLiveSlidesType = watch('secondaryLiveSlidesType');

  const handleMultiplePartUpload = async (selectedFile: any) => {
    setUploadPercentage(1);
    setVideoName(selectedFile[0].name);
    uploadPartUrl(
      rootUrl,
      singleVideo.id,
      singleVideo.title,
      selectedFile[0].name,
      singleVideo.channelId,
      selectedFile[0],
      false,
      setUploadPercentage,
      videoActions.uploadVideoRequestSuccess,
      isCancelUpload,
      true
    );
  };

  const handleSelectNewClick = (inputName: any) => {
    if (inputName.current) {
      inputName.current.click();
    }
  };
  const handleDownload = async (url: string, key: string) => {
    if (downloadingKey) return;
    setDownloadingKey(key);
    setDownloadProgress(0);
    toast.info('Download started. Large files may take a few minutes.');

    try {
      const response = await axios.get(url, {
        responseType: 'blob',
        onDownloadProgress: (e) => {
          if (e.total) {
            setDownloadProgress(Math.round((e.loaded * 100) / e.total));
          }
        }
      });
      saveAs(response.data, videoId);
      toast.success('Download complete');
    } catch (err) {
      console.error('Download failed', err);
      toast.error('Download failed. Please try again.');
    } finally {
      setDownloadingKey(null);
      setDownloadProgress(0);
    }
  };
  const slidesApiUrl = `${rootUrl}/v2/video/slides`;
  const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

  const fetchAllSlides = async () => {
    const pageSize = 50;
    let pageNumber = 1;
    let all: { imageURL: string; timeStamp: string }[] = [];
    let total = 0;
    do {
      const res = await axios.get(slidesApiUrl, {
        params: { VideoId: videoId, pageNumber, pageSize },
        headers: authHeaders()
      });
      const items = res.data?.result || [];
      total = res.data?.totalCount || 0;
      all = all.concat(items);
      if (items.length === 0) break;
      pageNumber++;
    } while (all.length < total);
    return all;
  };

  useEffect(() => {
    if (!videoId) return;
    axios
      .get(slidesApiUrl, {
        params: { VideoId: videoId, pageNumber: 1, pageSize: 1 },
        headers: authHeaders()
      })
      .then((res) => setSlideCount(res.data?.totalCount || 0))
      .catch(() => setSlideCount(0));
  }, [videoId]);

  const handleDownloadSlides = async () => {
    if (isZippingSlides) return;
    setIsZippingSlides(true);
    setSlidesZipProgress(0);
    toast.info('Preparing slides. This may take a moment.');

    try {
      const slides = await fetchAllSlides();
      if (!slides.length) {
        toast.error('No slides available to download.');
        return;
      }

      const zip = new JSZip();
      const usedNames = new Set<string>();
      const rows: string[] = ['filename,timeStamp'];
      let done = 0;

      const getFileName = (url: string) => {
        const name = decodeURIComponent(url.split('?')[0].split('/').pop() || 'slide.jpg');
        if (!usedNames.has(name)) {
          usedNames.add(name);
          return name;
        }
        const dot = name.lastIndexOf('.');
        let i = 1;
        let candidate = '';
        do {
          candidate = `${name.slice(0, dot)}_${i++}${name.slice(dot)}`;
        } while (usedNames.has(candidate));
        usedNames.add(candidate);
        return candidate;
      };

      const entries = slides
        .filter((s) => s.imageURL)
        .map((s) => ({ ...s, fileName: getFileName(s.imageURL) }));

      // download in small batches
      const batchSize = 5;
      for (let i = 0; i < entries.length; i += batchSize) {
        const batch = entries.slice(i, i + batchSize);
        await Promise.all(
          batch.map(async (s) => {
            const res = await axios.get(s.imageURL, { responseType: 'blob' });
            zip.file(s.fileName, res.data);
            done++;
            setSlidesZipProgress(Math.round((done * 100) / entries.length));
          })
        );
      }

      entries.forEach((s) => rows.push(`"${s.fileName}","${s.timeStamp}"`));
      zip.file('slides.csv', rows.join('\n'));

      const blob = await zip.generateAsync({ type: 'blob' });
      const safeTitle = (singleVideo?.title || videoId).replace(/[\\/:*?"<>|]/g, '').trim();
      saveAs(blob, `${safeTitle}-secondary.zip`);
      toast.success('Slides downloaded');
    } catch (err) {
      console.error('Slides download failed', err);
      toast.error('Slides download failed. Please try again.');
    } finally {
      setIsZippingSlides(false);
      setSlidesZipProgress(0);
    }
  };
  const handleSecondaryMediaChange = (e: any) => {
    const selectedItem = liveMedia && liveMedia.find((item) => item.id === e);
    if (selectedItem) {
      if (selectedItem.mediaLiveChannelId === singleVideo?.urls[0]?.mediaLiveChannelId) {
        setShowWarning(true);
      } else {
        setShowWarning(false);
      }
    }
  };

  const fetchSignedURL = () => {
    const rootUrl = process.env.REACT_APP_BASE_API_URL;
    const apiPath = '/v2/video/resource/upload';
    const fileName = resourceName.slice(0, -4);
    const fileType = resourceType;
    const bearerToken = localStorage.getItem('token');
    const payload: UpdateResourceUploadModel = {
      filename: fileName,
      filetype: fileType,
      resourceId: resourceId,
      title: singleVideo.title,
      channelid: singleVideo.channelId,
      thumbnailURL: ''
    };

    const apiUrl = `${rootUrl}${apiPath}?presentationId=${videoId}`;

    axios
      .post(apiUrl, JSON.stringify(payload), {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          'Content-Type': 'application/json'
        }
      })
      .then(async (response) => {
        const preSignedUrl = response.data.result.signedUrl;
        await uploadFileWithProgress(preSignedUrl);
        videoActions.getVideoMediaRequest(videoId);
      })
      .catch((error) => {
        console.error('Error during fetch:', error);
      });
  };
  const uploadFileWithProgress = (url: any) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', url, true);
      xhr.setRequestHeader('Content-Type', resourceType);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percentCompleted = Math.round((event.loaded * 100) / event.total);
          setUploadProgress(percentCompleted);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response);
          toast('success');
          setTimeout(() => {
            setUploadProgress(0);
            setResourceName('');
            setResourceType('');
            setSelectedFile('');
          }, 3000);
        } else {
          reject(xhr.statusText);
        }
      };

      xhr.onerror = () => reject(xhr.statusText);
      xhr.send(uploadedFile);
    });
  };

  const onSubmitExternalProduct = (data: any) => {
    videoActions.updateExternalProductLinkRequest({ ...data, videoId });
    setIsEditingUrl(false);
  };
  return (
    <div
      className="tab-pane fade"
      id="tabs-mediainfoView"
      role="tabpanel"
      aria-labelledby="tabs-mediainfo-view">
      <div className="p-5">
        <div className="font-bold text-lg mb-2">{singleVideo?.title}</div>
        {singleVideo.videoContentType === 2 ? (
          <>
            <form onSubmit={handleSubmit1(onSubmitExternalProduct)}>
              <div className="form-group">
                <label className="block text-sm font-medium mb-1">External Content URL</label>

                {!isEditingUrl ? (
                  // View Mode
                  <div className="flex items-center gap-3">
                    <div className="flex-1 px-3 py-2 bg-gray-50 border border-gray-200 rounded text-sm text-gray-700">
                      {watch1('externalContentUrl') || 'No URL set'}
                    </div>
                    <button
                      type="button"
                      onClick={() => setIsEditingUrl(true)}
                      className="p-2 hover:bg-gray-100 rounded transition-colors"
                      title="Edit URL">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-gray-600"
                        viewBox="0 0 20 20"
                        fill="currentColor">
                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                      </svg>
                    </button>
                  </div>
                ) : (
                  <div className="space-y-3">
                    <input
                      type="text"
                      className="input-style"
                      {...register1('externalContentUrl')}
                      autoFocus
                    />
                    <div className="flex gap-2">
                      <button
                        type="submit"
                        className="btn-primary w-auto mt-0 borderonly-btn border-gray-200 mx-0">
                        Update
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setIsEditingUrl(false);
                        }}
                        className="px-4 py-2 text-sm border border-gray-300 rounded hover:bg-gray-50 transition-colors">
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </>
        ) : (
          <div>
            {singleVideo &&
              singleVideo.videoContentType !== 1 &&
              (singleVideo.videoStatus === 0 ||
                singleVideo.videoStatus === 1 ||
                singleVideo.videoStatus === 3) && (
                <>
                  <label className="font-black text-lg">Live</label>
                  <div className="flex items-center">
                    <div className="flex my-5">
                      <Link
                        to={`/videos/live-event/${videoId}`}
                        className="btn-primary w-48 mt-0 mx-0 borderonly-btn">
                        Live Studio
                      </Link>
                    </div>
                    <div>
                      <select
                        className="input-style ml-2"
                        onChange={(e) => handleChangeVideoSource(e.target.value)}>
                        {productAccess && productAccess.liveMeeting ? (
                          <>
                            <option
                              selected={videoMedia.liveStreamSource === 'Webcam' ? true : false}
                              value={1}>
                              Webcam
                            </option>
                            <option
                              selected={
                                videoMedia.liveStreamSource === 'Streaming Software' ? true : false
                              }
                              value={2}>
                              Streaming Software
                            </option>
                            <option
                              selected={
                                videoMedia.liveStreamSource === 'Low Latency Meeting' ? true : false
                              }
                              value={3}>
                              Low Latency Meeting
                            </option>
                          </>
                        ) : (
                          <>
                            <option
                              selected={videoMedia.liveStreamSource === 'Webcam' ? true : false}
                              value={1}>
                              Webcam
                            </option>
                            <option
                              selected={
                                videoMedia.liveStreamSource === 'Streaming Software' ? true : false
                              }
                              value={2}>
                              Streaming Software
                            </option>
                          </>
                        )}
                      </select>
                    </div>
                  </div>
                </>
              )}
            {
              (singleVideo.videoSourceId == 1) && (
                <div className="mt-3 mb-2">
                  <label className="font-semibold text-sm">Live Studio URL</label>
                  <div className="flex items-center mt-2 gap-2">
                    <div className="flex-1 px-3 py-2 bg-gray-50 border border-gray-200 rounded text-sm text-gray-700 truncate">
                      {`${window.location.origin}/videos/live-event/${videoId}`}
                    </div>
                    <button
                      type="button"
                      onClick={handleCopyLiveStudioUrl}
                      className={`flex items-center gap-1 px-3 py-2 text-sm border rounded transition-colors whitespace-nowrap ${isCopied
                        ? 'bg-green-50 border-green-300 text-green-600'
                        : 'border-gray-300 hover:bg-gray-100 text-gray-600'
                        }`}
                      title="Copy to clipboard">
                      {isCopied ? (
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                          Copied!
                        </>
                      ) : (
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
                            <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z" />
                          </svg>
                          Copy
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )
            }

            {singleVideo && singleVideo.videoContentType === 1 && (
              <>
                <div className="modal-body relative py-4">
                  <form>
                    <label className="font-semibold">Replace Media:</label>
                    <div className={`form-group my-5`}>
                      <div className="input-style p-0 speaker-browse-file flex items-center">
                        <input id="uploadFile" className="pl-2" placeholder={`${selectedFile}`} />
                        <div className="fileUpload btn btn-primary mt-0 ml-auto mr-0 px-1 w-28">
                          <span>Select File</span>
                          <input
                            id="uploadBtn"
                            type="file"
                            className="upload"
                            onChange={(e) => handleResourceUpload(e.target.files)}
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="flex items-center  whitespace-nowrap">
                  {uploadProgress !== 0 && resourceName !== '' && (
                    <div
                      className={`w-full ${uploadProgress === 100 ? 'bg-green-100' : 'bg-purple-100'
                        } h-3 rounded-full mt-4`}>
                      <div
                        className={` ${uploadProgress === 100 ? 'bg-green-400' : 'bg-purple-600'
                          } text-white text-xs h-3 font-medium text-center leading-none rounded-full`}
                        style={{ width: `${Math.floor(uploadProgress)}%` }}>
                        {Math.floor(uploadProgress)}%
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}

            <div className="my-5">
              <label className="font-black text-lg">Primary Media</label>
              <div className="flex items-center mt-3">
                {videoMedia?.primaryUrl?.mP4URL && (
                  <button
                    onClick={() => handleDownload(videoMedia.primaryUrl.mP4URL, 'primary')}
                    type="button"
                    disabled={!!downloadingKey}
                    className="btn-primary w-auto mt-0 borderonly-btn border-gray-200 mx-0 mr-3 disabled:opacity-60 disabled:cursor-not-allowed">
                    {downloadingKey === 'primary' ? (
                      <>
                        <i className="fas fa-spinner fa-spin mr-1"></i>
                        Downloading… {downloadProgress > 0 ? `${downloadProgress}%` : ''}
                      </>
                    ) : (
                      <>
                        <i className="fas fa-download mr-1"></i> Download
                      </>
                    )}
                  </button>
                )}

                {videoMedia?.resourceUrl && (
                  <button
                    onClick={() => handleDownload(videoMedia.resourceUrl, 'resource')}
                    type="button"
                    disabled={!!downloadingKey}
                    className="btn-primary w-auto mt-0 borderonly-btn border-gray-200 mx-0 mr-3 disabled:opacity-60 disabled:cursor-not-allowed">
                    {downloadingKey === 'resource' ? (
                      <>
                        <i className="fas fa-spinner fa-spin mr-1"></i>
                        Downloading… {downloadProgress > 0 ? `${downloadProgress}%` : ''}
                      </>
                    ) : (
                      <>
                        <i className="fas fa-download mr-1"></i> Download
                      </>
                    )}
                  </button>
                )}
                {downloadingKey && (
                  <div className="w-full bg-purple-100 h-3 rounded-full mt-3">
                    <div
                      className="bg-purple-600 h-3 rounded-full transition-all"
                      style={{ width: `${downloadProgress}%` }}
                    />
                  </div>
                )}
                {singleVideo && singleVideo.videoContentType !== 1 && (
                  <Link
                    to={`/videos/replace/${videoId}`}
                    className="btn-primary w-auto mt-0 borderonly-btn border-gray-200 mx-0">
                    {`${videoMedia && videoMedia.primaryUrl && videoMedia.primaryUrl.mP4URL
                      ? 'Replace'
                      : 'Upload'
                      }`}
                  </Link>
                )}
              </div>
            </div>

            {singleVideo && singleVideo.videoContentType !== 1 && (
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="md:flex items-center my-8">
                  <div className="md:w-3/12">
                    <label
                      className="form-check-label inline-block switch-label mr-5 font-black text-lg"
                      htmlFor="Credit">
                      Secondary Media
                    </label>
                  </div>
                  <div className="md:w-10/12 mr-20">
                    <div className="flex items-center">
                      <div className="form-check form-switch pl-0 flex justify-between items-center mb-2">
                        <div className="relative">
                          <input
                            className="form-check-input switch-btn"
                            type="checkbox"
                            role="switch"
                            id="isSecondary"
                            {...register('isSecondary')}
                          />
                          <i className="fas fa-check checkbox-tick hidden"></i>
                          <i className="fas fa-times checkbox-cross"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {isSecondary && (
                  <div className="md:flex items-center my-8">
                    <div className="md:w-3/12">
                      <label
                        className="form-check-label inline-block switch-label mr-5 font-black text-lg"
                        htmlFor="Credit">
                        Secondary Media Type
                      </label>
                    </div>
                    <div className="md:w-10/12 mr-20">
                      <div className="flex items-center">
                        <div className="md:w-10/12 mr-20">
                          <select
                            className="input-style ml-2"
                            id="secondaryLiveSlidesType"
                            {...register('secondaryLiveSlidesType')}>
                            <option value="">Select</option>
                            <option value={0}>Slides</option>
                            <option value={1}>Video</option>
                            <option value={2}>Both</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {isSecondary && (secondaryLiveSlidesType == 1 || secondaryLiveSlidesType == 2) && (
                  <div className="md:flex items-center my-8">
                    <div className="md:w-3/12">
                      <label
                        className="form-check-label inline-block switch-label mr-5 font-black text-lg"
                        htmlFor="Credit">
                        Live Video Media
                      </label>
                    </div>
                    <div className="md:w-10/12 mr-20">
                      <div className="flex items-center">
                        <div className="md:w-10/12 mr-20">
                          <select
                            className="input-style ml-2"
                            id="secondaryLiveMedia"
                            {...register('secondaryLiveMedia', {
                              onChange: (e: any) => {
                                handleSecondaryMediaChange(e.target.value);
                              }
                            })}>
                            <option value="">Select</option>
                            {liveMedia &&
                              liveMedia.map((item) => {
                                return (
                                  <option key={item.id} value={item.id}>
                                    {item.mediaName}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className=" my-8">
                  {showWarning && (
                    <p className="font-semibold text-red-600">
                      You have selected the same Live Media Channel for both Primary and Secondary
                      stream. This means that the same media will be displayed twice in the live
                      stream. Are you sure you want to continue?
                    </p>
                  )}

                  <div className="md:w-3/12">
                    <button
                      type="submit"
                      className="btn-primary w-auto mt-0 borderonly-btn border-gray-200 mx-0 ml-6">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            )}
            {(watch('secondaryLiveSlidesType') == 1 || watch('secondaryLiveSlidesType') == 2) && (
              <div className="mb-5">
                <label className="font-semibold">Video</label>
                {uploadPercentage !== 0 && videoName !== '' && (
                  <div
                    className={`w-full ${uploadPercentage === 100 ? 'bg-green-100' : 'bg-purple-100'
                      } h-3 rounded-full mt-4`}>
                    <div
                      className={` ${uploadPercentage === 100 ? 'bg-green-400' : 'bg-purple-600'
                        } text-white text-xs h-3 font-medium text-center leading-none rounded-full`}
                      style={{ width: `${Math.floor(uploadPercentage)}%` }}>
                      {Math.floor(uploadPercentage)}%
                    </div>
                  </div>
                )}
                <div className="mt-3">
                  <div className="video-upload-btn flex-items">
                    <label
                      onClick={() => handleSelectNewClick(secondaryUploadMediaBtn)}
                      className="btn-primary cursor-pointer w-auto mx-0 mt-1">
                      Upload Secondary Video
                    </label>

                    <input
                      ref={secondaryUploadMediaBtn}
                      id="uploadBtns"
                      type="file"
                      className="hidden"
                      onChange={(e) => handleMultiplePartUpload(e.target.files)}
                    />
                  </div>
                </div>
              </div>
            )}
            {(watch('secondaryLiveSlidesType') == 0 || watch('secondaryLiveSlidesType') == 2) && (
              <>
                <label className="font-semibold">Slides</label>
                <div className="flex my-5">
                  <Link
                    to={`/videos/upload-slides/${videoId}`}
                    className="btn-primary w-48 mt-0 mx-0 borderonly-btn">
                    Upload Slides
                  </Link>

                  <Link to={`/videos/manage-slides/${videoId}`} className="btn-primary w-48 mt-0 mx-0 discard-btn">
                    Manage Slides
                  </Link>

                  {slideCount > 0 && (
                    <button
                      type="button"
                      onClick={handleDownloadSlides}
                      disabled={isZippingSlides}
                      className="btn-primary w-48 mt-0 mx-0 ml-3 borderonly-btn disabled:opacity-60 disabled:cursor-not-allowed">
                      {isZippingSlides ? (
                        <>
                          <i className="fas fa-spinner fa-spin mr-1"></i>
                          Zipping… {slidesZipProgress > 0 ? `${slidesZipProgress}%` : ''}
                        </>
                      ) : (
                        <>
                          <i className="fas fa-download mr-1"></i> Download Slides
                        </>
                      )}
                    </button>
                  )}
                </div>
              </>
            )}

            <div className="mb-5">
              <label className="font-black text-lg">Media</label>
              {singleVideo &&
                singleVideo?.useLowLatencyLiveMeeting &&
                videoMedia.liveStreamSource == 'Low Latency Meeting' && (
                  <div className="md:flex items-center my-8">
                    <div className="md:w-2/12">
                      <label className="font-semibold">Live Meeting ID</label>
                    </div>
                    <div className="md:w-10/12">
                      <div>
                        <p>{videoMedia?.liveMeetingId}</p>
                      </div>
                    </div>
                  </div>
                )}
              {singleVideo && singleVideo.videoContentType !== 1 && (
                <div className="md:flex items-center my-8">
                  <div className="md:w-2/12">
                    <label className="font-semibold">HLS Media URL</label>
                  </div>
                  <div className="md:w-10/12">
                    <div>
                      <p>{videoMedia && videoMedia?.primaryUrl?.mediaUrl}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {singleVideo && singleVideo.videoContentType === 1 ? (
              <div className="mb-5">
                <div className="md:flex items-center my-8">
                  <div className="md:w-2/12">
                    <label className="font-semibold">Resource URL</label>
                  </div>
                  <div className="md:w-10/12">
                    <div>
                      <p>{videoMedia && videoMedia?.resourceUrl}</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="mb-5">
                <div className="md:flex items-center my-8">
                  <div className="md:w-2/12">
                    <label className="font-semibold">MP4 Media URL</label>
                  </div>
                  <div className="md:w-10/12">
                    <div>
                      <p>{videoMedia && videoMedia?.primaryUrl?.mP4URL}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {singleVideo && singleVideo.videoContentType !== 1 && (
              <div className="mb-5">
                <div className="md:flex items-center my-8">
                  <div className="md:w-2/12">
                    <label className="font-semibold">Secondary Media HLS URL</label>
                  </div>
                  <div className="md:w-10/12">
                    <p>{videoMedia && videoMedia?.secondaryUrl?.mediaUrl}</p>
                  </div>
                </div>
              </div>
            )}
            {singleVideo && singleVideo.videoContentType !== 1 && (
              <div className="mb-5">
                <div className="md:flex items-center my-8">
                  <div className="md:w-2/12">
                    <label className="font-semibold">Secondary Media MP4 URL</label>
                  </div>
                  <div className="md:w-10/12">
                    <p>{videoMedia && videoMedia?.secondaryUrl?.mP4URL}</p>
                  </div>
                </div>
              </div>
            )}
            {videoMedia && videoMedia?.primaryUrl?.mP3Url && (
              <div className="mb-5">
                <div className="md:flex items-center my-8">
                  <div className="md:w-2/12">
                    <label className="font-semibold">MP3 URL</label>
                  </div>
                  <div className="md:w-10/12">
                    <p>{videoMedia && videoMedia?.primaryUrl?.mP3Url}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MediaInfo;
